import React, { Component } from "react";

class TimelineMarker extends Component {

    componentDidUpdate(prevProps) {

        const { dateTriggered: prevDateTriggered } = prevProps;
        const { dateTriggered, isPlaying } = this.props;

        if (isPlaying && !prevDateTriggered && dateTriggered) {
            const audio = new Audio('old-church-bell.mp3');
            audio.play();
        }
    }

    render() {
        const { dateTriggered, dateKilledPosition } = this.props;
        const strokeColour = dateTriggered ? 'rgb(255,0,0)' : 'rgb(100, 100, 100)';

        return (
            <line x1={`${dateKilledPosition}%`} y1={10}
                  x2={`${dateKilledPosition}%`} y2={25}
                  stroke={strokeColour}
                  strokeLinecap={'round'}/>
        );
    }
}

export default TimelineMarker;


// WEBPACK FOOTER //
// ./src/app/components/TimelineMarker.js